<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <h2 class="text-h5 font-weight-bold">Reportes - Clientes</h2>
        <div class="subtitle-2 grey--text">Listado de reportes disponibles para clientes y cartera.</div>
      </v-col>
    </v-row>

    <legacy-reports-group-cards group="customers" />
  </v-container>
</template>

<script>
import LegacyReportsGroupCards from '@/components/reports/LegacyReportsGroupCards.vue';

export default {
  name: 'ReportsClientsSectionView',
  components: { LegacyReportsGroupCards },
};
</script>
